import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './footer.css'

export const Footer = () => {
  return (
    <React.Fragment>
        <Container className='ppnc__footer' fluid>
            <Row>
                <p > &copy; copyright 2022  |  MINT YOUR NFT</p>
            </Row>
        </Container>
    </React.Fragment>
  )
}
